import { ButtonGroup, PrimaryButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { useLanguage } from "@digipost/translate";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";

import { RegistrationStatus } from "../infrastructure/redux/org/org-actions";
import { ReduxState } from "../infrastructure/redux/state";
import Translated from "../infrastructure/Translated";
import { useRootPath } from "../infrastructure/useRootPath";
import { useTranslate } from "../infrastructure/useTranslate";
import RegisterFlowStepper from "../registrer/RegisterFlowStepper";
import mannMedNettbrett from "./mann_med_nettbrett.svg";
import styles from "./ManuellConfirm.module.css";

const ManuellFlowConfirmation: FC = () => {
  const translate = useTranslate();
  const rootPath = useRootPath();
  const { language } = useLanguage();

  const { nonce, redirectUrl } = useSelector(
    (state: ReduxState) => state.app.params,
  );
  const registrationStatus = useSelector(
    (state: ReduxState) => state.org.registrationStatus,
  );
  const selectedIntegrationPartner = useSelector(
    (state: ReduxState) => state.org.userInput?.selectedIntegrationPartner,
  );

  const selectedOrganisationNumber = useSelector(
    (state: ReduxState) => state.org.userInput?.selectedOrganisationNumber,
  );

  // Guard for tilfeldig navigering
  useEffect(() => {
    if (registrationStatus !== RegistrationStatus.COMPLETE) {
      window.location.href = `${rootPath}/bedrift`;
    }
  }, [registrationStatus]);

  const forsiden = location.pathname.includes("bedrift")
    ? language === "en"
      ? "/en/business"
      : `${language === "nb" ? "" : "/nn"}/bedrift`
    : `/${language}`;
  const integrationPartnerFlow = !!selectedIntegrationPartner;
  const integrationPartnerName = selectedIntegrationPartner?.name ?? "";

  const goToNext = integrationPartnerFlow
    ? `${redirectUrl}?nonce=${nonce}&organisation-number=${selectedOrganisationNumber}`
    : forsiden;

  return (
    <main>
      <Heading level={1} size="large">
        <Translated textKey="register.org.manual.form.submitted.heading" />
      </Heading>
      <RegisterFlowStepper currentStep="COMPLETE" />
      <div className={styles.contentWrapper}>
        <div>
          {integrationPartnerFlow ? (
            <p>
              <Translated textKey="register.org.manual.form.submitted.with_partner_text" />
              &nbsp;{integrationPartnerName}.&nbsp;
              <Translated textKey="register.org.manual.form.submitted.text" />
            </p>
          ) : (
            <p>
              <Translated textKey="register.org.manual.form.submitted.text" />
            </p>
          )}

          <p>
            <Translated textKey="generic.have_a_nice_day" />
          </p>

          <ButtonGroup>
            <PrimaryButton as="a" href={goToNext}>
              {integrationPartnerFlow ? (
                <Translated
                  textKey="register.org.complete_partner"
                  params={{ partnername: integrationPartnerName }}
                />
              ) : (
                <Translated textKey="generic.back_to_front_page" />
              )}
            </PrimaryButton>
          </ButtonGroup>
        </div>

        <img
          className={styles.illustration}
          src={mannMedNettbrett}
          alt={translate("confirm.man_with_tablet")}
        />
      </div>
    </main>
  );
};

export default ManuellFlowConfirmation;
